module.exports = __webpack_public_path__ + "static/media/screenshot_desktop-ar.9da7c843.png";